<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name" #title>権限設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <!-- ここから画面の内容を記述 -->
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">ID</label>
            <div class="list-input-content" style="width: 7rem;">
              <input type="text" readonly [(ngModel)]="kymw9004Model.authoritySetId">
            </div>

            <label class="list-input-title">セット名</label>
            <div class="list-input-content">
              <app-not-null-text-input type="text" class="text-label-required" id="txt_authoritySetName" #txt_authoritySetName
              [(ngModel)]="kymw9004Model.authoritySetName" [displayCountField]="false" [maxChars]="25"
              [subid]="'txt_authoritySetName'" [restrict]="'[ -￮]'"></app-not-null-text-input>
            </div>

            <label class="list-input-title">管理者権限</label>
            <div class="list-input-content">
              <app-checkbox-label id="chk_AdminDiv" #chk_AdminDiv [subid]="'chk_AdminDiv'" label="権限付与"
                [(ngModel)]="kymw9004Model.check_AdminDiv" [tabindex]="0">
              </app-checkbox-label>
            </div>

            <label class="list-input-title">有効/無効</label>
            <div class="list-input-content">
              <app-radio-label label="有効" value="0" [(ngModel)]="kymw9004Model.authorityStatus"
                name="grp_authorityStatus">
              </app-radio-label>
              <app-radio-label label="無効" value="1" [(ngModel)]="kymw9004Model.authorityStatus"
                name="grp_authorityStatus">
              </app-radio-label>
            </div>

            <label class="list-input-title">説明</label>
            <div class="list-input-content">
              <app-text-area id="txta_AuthoritySetExplanation" #txta_AuthoritySetExplanation
                [subid]="'txta_AuthoritySetExplanation'" [(ngModel)]="kymw9004Model.authoritySetExplanation"
                [maxChars]="600" wordWrap="true" [displayCountField]="false" [restrict]="'[ -￮]'"
                [forcedEnabledMode]="'none'" [tabindex]="0" [height]="90">
              </app-text-area>
            </div>
          </div>

          <wj-flex-grid [style.width.px]="578" [style.height.px]="460" id="dgt_FuncAuthorityList" #dgt_FuncAuthorityList
            [itemsSource]="kymw9004Model.funcAuthorityList" [isReadOnly]="true" [allowSorting]="false"
            [allowDragging]="'None'" [headersVisibility]="'Column'" [selectionMode]="'Row'" forcedEnabledMode="true"
            [tabindex]="0">
            <wj-flex-grid-column [minWidth]="5" [width]="418" [header]="'画面名'"
              [binding]="'FuncName'"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'権限'" [binding]="'EnableMode'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <select [style.width.px]="120" class="text-label-required" id="FuncAuthorityComboBox"
                  [(ngModel)]="cell.item.EnableMode" [disabled]="this.getFuncPermission() !== '2'" [tabindex]="-1">
                  <option value="2">フルコントロール</option>
                  <option value="1">参照のみ</option>
                  <option value="0">使用不可</option>
                </select>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_Set" #btn_Set (click)="eventSet_CLICKHandler()">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>